/**
 * Created by piotr.pozniak@thebeaverhead.com on 18/07/2023
 *
 * Renamed from QueuedEmbeddingJobs.js — the file was misnamed (title/
 * jobType/route are all "Email", not "Embedding").
 */
import React from "react";
import QueueJobsListPage from "./QueueJobsPage/QueueJobsListPage";

const QueuedEmailJobs = () => (
  <QueueJobsListPage title="Email jobs" jobType="Email" routeBase="/email-jobs" iconField="integration_type" />
);

export default QueuedEmailJobs;
